import React, { useEffect, useMemo, useState } from "react";
import { normalizeTicketMessageBody } from "../utils/normalizeTicketMessageBody";

const markdownComponents = {
  a: ({ href, children }) => (
    <a
      href={href}
      className="link-row break-all underline"
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  ),
  img: ({ src, alt }) => (
    <img
      src={src}
      alt={alt || ""}
      loading="lazy"
      className="my-1 inline-block max-h-16 max-w-full object-contain align-middle"
    />
  ),
  p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
  ul: ({ children }) => <ul className="mb-2 list-disc pl-5 last:mb-0">{children}</ul>,
  ol: ({ children }) => <ol className="mb-2 list-decimal pl-5 last:mb-0">{children}</ol>,
  li: ({ children }) => <li className="mb-1">{children}</li>,
};

function PlainMessageBody({ body }) {
  return <p className="whitespace-pre-wrap leading-relaxed">{body}</p>;
}

export default function TicketMessageBody({ body }) {
  const normalized = useMemo(() => normalizeTicketMessageBody(body), [body]);
  const [MarkdownBody, setMarkdownBody] = useState(null);

  useEffect(() => {
    let cancelled = false;

    Promise.all([import("react-markdown"), import("remark-breaks")]).then(
      ([{ default: ReactMarkdown }, { default: remarkBreaks }]) => {
        if (cancelled) return;

        function RenderedMarkdown({ content }) {
          return (
            <ReactMarkdown remarkPlugins={[remarkBreaks]} components={markdownComponents}>
              {content}
            </ReactMarkdown>
          );
        }

        setMarkdownBody(() => RenderedMarkdown);
      },
    );

    return () => {
      cancelled = true;
    };
  }, []);

  if (!normalized) {
    return null;
  }

  return (
    <div className="ticket-message-body text-sm leading-relaxed">
      {MarkdownBody ? <MarkdownBody content={normalized} /> : <PlainMessageBody body={normalized} />}
    </div>
  );
}
